import { defineComponent as _defineComponent } from 'vue'
import { Navigation, Pagination } from 'swiper'


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderProductsNavigation',
  props: {
  nextEl: {
    type: String,
  },
  prevEl: {
    type: String,
  },
  paginationEl: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const modules = [Navigation, Pagination]

const breakpoints = {
  0: {
    slidesPerView: 1,
  },
  768: {
    slidesPerView: 2,
  },
}

const __returned__ = { props, modules, breakpoints, get Navigation() { return Navigation }, get Pagination() { return Pagination } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})